"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionSet = void 0;
class SubscriptionSet {
    constructor(subscriptions = new Set()) {
        this.subscriptions = subscriptions;
    }
    add(subscription) {
        subscription.add(() => {
            this.subscriptions.delete(subscription);
        });
        this.subscriptions.add(subscription);
    }
    unsubscribe() {
        this.subscriptions.forEach((s) => s.unsubscribe());
    }
}
exports.SubscriptionSet = SubscriptionSet;
